import React, { useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import useCompany from '../../../hooks/useCompany';
import { Button } from '@oc-labs/wt-storybook';

const AcceptInvitation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const { acceptInvitation } = useAuth();
    const { refetchCompanies, refetchActiveCompany } = useCompany();

    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);

    const token = useMemo(() => {
        if (params.token) return params.token;
        const searchParams = new URLSearchParams(location.search);
        return searchParams.get('organizationInvitationToken');
    }, [params.token, location.search]);

    // Si no hay token
    if (!token) {
        return (
            <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden p-8 sm:p-10">
                <div className="text-center">
                    <h1 className="text-2xl font-bold text-slate-900 mb-2">
                        Invalid invitation
                    </h1>
                    <p className="text-slate-600">
                        The invitation link is incorrect or has expired.
                    </p>
                </div>
            </div>
        );
    }

    const handleAcceptInvitation = async () => {
        setLoading(true);
        setErrorMsg(null);

        try {
            await acceptInvitation(token);

            window.location.href = '/dashboard/home';
        } catch (error) {
            if (
                error?.code === 'INVITATION_NOT_FOUND' ||
                error?.message?.includes('Invitation not found')
            ) {
                setErrorMsg(
                    'This invitation has already been used or does not exist. If you already have access, go to the dashboard.'
                );
            } else {
                setErrorMsg(
                    'Error accepting the invitation. Please try again or contact support.'
                );
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden p-8 sm:p-10">
            <div className="text-center mb-8">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    Accept Invitation
                </h1>
                <p className="text-slate-600">
                    Do you want to accept the invitation?
                </p>

                {errorMsg && (
                    <div className="mt-4 text-red-600">{errorMsg}</div>
                )}
            </div>

            <Button
                type="primary"
                className="w-full"
                onClick={handleAcceptInvitation}
                disabled={loading}
            >
                {loading ? 'Accepting...' : 'Accept Invitation'}
            </Button>
        </div>
    );
};

export default AcceptInvitation;